var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"active":_vm.isLoading,"loader":"spinner","color":"#1a8de9","background-color":"#eee","height":64,"width":64},on:{"update:active":function($event){_vm.isLoading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }